import React, { useState, useEffect } from 'react';
import { Row, Col, Carousel } from 'antd';
import '../../assets/css/caracteristicas.css';

import img_conferencias from '../../assets/images/2026/Logos-Botones/Icono_Conferencias.png';
import img_mesas from '../../assets/images/2026/Logos-Botones/Icono_Mesas.png';
import img_repeticion from '../../assets/images/2026/Logos-Botones/Icono_Ondemand.png';
import img_facilidad from '../../assets/images/2026/Logos-Botones/Icono_Pago.png';

import img_banners from '../../assets/images/2026/banner.jpg';


const AcercaDe = (props) => {
    const { idioma } = props;
    return (
        <>
        
            <Row align='middle'>
                <Col xs={{span:24, offset:0}} md={{span:14, offset:5}}>
                    <br />
                    <p className='titulo_seccion_2 inter'>ACERCA DE</p>
                </Col>
                <Col xs={{span:20, offset:2}} md={{span:10, offset:2}}>
                    {idioma === 'es' ?
                    <>
                    <p className='titulo_acercade'><strong>Seminario Iluminación IES México 2026</strong></p>
                        <p className="texto_acercade">
                            Desde hace más de 28 años se ha realizado exitosamente este foro anual de encuentro de profesionales que <strong>intercambian ideas, inspiración y conocimiento</strong> permitiendo un espacio de convivencia y establecimiento de contactos. La afluencia promedio de los últimos seminarios presenciales ha sido de <strong>más de 200 participantes</strong> relacionados con la iluminación, <i><strong>como diseñadores, arquitectos, ingenieros, fabricantes, comerciantes, instaladores, científicos y funcionarios públicos.</strong></i><br /><br />
                            Hoy podemos afirmar que nuestro Seminario se ha convertido en <span style={{color:'#0050a4'}}><strong>el evento de iluminación más importante de México,</strong></span> y es reconocido en todo el mundo porque participan conferencistas influyentes y destacados a nivel nacional e internacional, quienes no sólo comparten su conocimiento y experiencia, sino que también dan un auténtico testimonio del profesionalismo demostrado en la organización del evento, así como de la calidez y hospitalidad de nuestro país y de la comunidad de iluminación local.
                        </p>
                        </>
                        :
                        <></>}
                </Col>
                <Col xs={{span:20, offset:2}} md={{span:9, offset:1}}>
                   <img src={img_banners} style={{width:'100%'}} alt='info' />
                    <br />
                </Col>
                <Col xs={{span:20, offset:2}} md={{span:16, offset:4}}>
                    <Row justify='space-around'>
                        <Col xs={{span:10}} md={{span:4}}>
                            <img src={idioma === 'es' ? img_conferencias : img_conferencias} className='img_acercade_icono' alt='conferencias' />
                        </Col>
                        <Col xs={{span:10}} md={{span:4}}>
                            <img src={idioma === 'es' ? img_mesas : img_mesas} className='img_acercade_icono' alt='mesas cruzadas' />
                        </Col>
                        <Col xs={{span:10}} md={{span:4}} style={{display:'none'}}>
                            <img src={idioma === 'es' ? img_repeticion : img_repeticion} className='img_acercade_icono' alt='ondemand' />
                        </Col>
                        <Col xs={{span:10}} md={{span:4}}>
                            <img src={idioma === 'es' ? img_facilidad : img_facilidad} className='img_acercade_icono' alt='pago' />
                        </Col>
                    </Row>
                </Col>
                <Col span={24}>
                    <br /><br />
                </Col>
            </Row>
        </>
    )
}
export default AcercaDe;